module.exports = __webpack_public_path__ + "static/media/krimskayaZimaPreview.cb11fb15.jpg";